import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { MercadoPagoOrderRequestDto, MercadoPagoRequestDto, PagoResultadoDto, PaymentOrderResultDto, StartAllariaCheckoutResultDto, AllariaReturnResultDto } from '../payments/dto/models';
import type { CreateOrderWithItemsDto } from './models';

@Injectable({
  providedIn: 'root',
})
export class MercadoPagoOrderService {
  apiName = 'Default';


  confirmPaymentAndCreateOrderByDto = (dto: MercadoPagoOrderRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PaymentOrderResultDto>({
      method: 'POST',
      url: '/api/app/mercado-pago-order/confirm-payment-and-create-order',
      body: dto,
    },
    { apiName: this.apiName,...config });


  confirmPaymentByDto = (dto: MercadoPagoRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagoResultadoDto>({
      method: 'POST',
      url: '/api/app/mercado-pago-order/confirm-payment',
      body: dto,
    },
    { apiName: this.apiName,...config });

  // winepassport-api#60 — Allaria+ (Web-Checkout)
  startAllariaCheckout = (dto: CreateOrderWithItemsDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StartAllariaCheckoutResultDto>({
      method: 'POST',
      url: '/api/app/mercado-pago-order/start-allaria-checkout',
      body: dto,
    },
    { apiName: this.apiName,...config });

  confirmAllariaReturn = (clientPurchaseId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, AllariaReturnResultDto>({
      method: 'POST',
      url: `/api/app/mercado-pago-order/confirm-allaria-return/${clientPurchaseId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
